import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function Slide6_WhatWeDo() {
  return <SlideLayout data-id="element-177">
      <div className="flex flex-col h-full justify-center space-y-16" data-id="element-178">
        <div className="space-y-6" data-id="element-179">
          <h2 className="text-4xl md:text-5xl font-bold text-white" data-id="element-180">
            We don't just send applicants. We build and maintain your recruiting
            engine.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-181">
          {/* What We Do */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-182">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center" data-id="element-183">
              <Check className="w-6 h-6 text-emerald-500 mr-3" data-id="element-184" />
              What HIRE Does
            </h3>
            <ul className="space-y-4" data-id="element-185">
              {['Build and run the recruiting system', 'Own traffic, screening, and qualification', 'Design hiring standards and interview structure', 'Track early performance and fix issues', 'Provide Sales School and launch readiness', 'Deliver predictable, qualified candidates'].map((item, idx) => <motion.li key={idx} className="flex items-start text-slate-300" initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.3 + idx * 0.1
            }} data-id="element-186">
                  <span className="w-2 h-2 rounded-full bg-emerald-500 mr-3 mt-2 flex-shrink-0" data-id="element-187" />
                  <span data-id="element-188">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* What We Don't Do */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-189">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center" data-id="element-190">
              <X className="w-6 h-6 text-slate-500 mr-3" data-id="element-191" />
              What HIRE Doesn't Do
            </h3>
            <ul className="space-y-4" data-id="element-192">
              {['Make final hiring decisions', 'Run your sales team', 'Set compensation or culture', 'Replace internal leadership', 'Guarantee specific outcomes'].map((item, idx) => <motion.li key={idx} className="flex items-start text-slate-400" initial={{
              opacity: 0,
              x: 10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + idx * 0.1
            }} data-id="element-193">
                  <span className="w-2 h-2 rounded-full bg-slate-600 mr-3 mt-2 flex-shrink-0" data-id="element-194" />
                  <span data-id="element-195">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>

        <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 text-center" data-id="element-196">
          <p className="text-slate-300 text-lg" data-id="element-197">
            HIRE is accountable for the recruiting system working.{' '}
            <span className="text-white font-medium" data-id="element-198">
              You stay accountable for the business.
            </span>
          </p>
        </div>
      </div>
    </SlideLayout>;
}